import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import isEmpty from "lodash/isEmpty";
import styles from "./UploadComponent.module.scss";
import { useAppSelector } from "../../../redux/hooks";
import uploadDocIconLight from "../../../assets/images/LightTheme/upload_img_light.svg";
import uploadDocIconDark from "../../../assets/images/DarkTheme/upload_img_dark.svg";
// import { ALLOWED_FILE_TYPES } from "../../../constants/dataConstants";
import { SuccessionPlanFileType } from "../../../types/types";
import { addDragDropListeners, createDragHandlers, removeDragDropListeners, handleFileInputChange, type DragHandlers } from "../../../utils/upload";

interface UploadComponentProps {
  handlePersistSelectedFile: (file: SuccessionPlanFileType) => void;
  isSourceAP?: boolean;
  isSourceHatv?: boolean;
  allowedFileSize?: number;
}

const UploadComponent: React.FC<UploadComponentProps> = ({
  handlePersistSelectedFile,
  isSourceAP,
  isSourceHatv,
  allowedFileSize = 10 * 1024 * 1024,
}) => {
  const { t } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);
  const dragDropRef = useRef<HTMLInputElement  | null>(null);
  const [isDragOver, setIsDragOver] = useState(false);
  const [selectedFile, setSelectedFile] = useState<SuccessionPlanFileType>();

  const dragHandlersRef = useRef<DragHandlers | null>(null);

  useEffect(() => {
    !isEmpty(selectedFile) && handlePersistSelectedFile(selectedFile);
  }, [selectedFile]);

  useEffect(() => {
    const node = dragDropRef.current as unknown as HTMLElement | null;
    if (node) {
      const handlers = createDragHandlers(setIsDragOver, (e: any) => onFileChange(e));
      dragHandlersRef.current = handlers;
      addDragDropListeners(node, handlers);
      return () => {
        if (dragHandlersRef.current) {
          removeDragDropListeners(node, dragHandlersRef.current);
        }
      };
    }
  }, []);

  // Use shared handler to avoid duplicated FileReader logic
  const onFileChange = (event: any) => {
    handleFileInputChange(
      event,
      allowedFileSize,
      (selected) => {
        setSelectedFile(selected as unknown as SuccessionPlanFileType);
      },
      (file) => {
        console.info(">>> File too large:", file?.name);
      },
      (file) => {
        console.info(">>> Error loading file", file?.name);
      }
    );
  };

  const handleClick = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  const currentTheme = useAppSelector((state: any) => state.theme.currentTheme);
  const uploadDocIcon =
    currentTheme === "light" ? uploadDocIconLight : uploadDocIconDark;

  return (
    <div className={`upload_container ${styles.upload_container}`} data-testid="upload_document_testID">
      {/* <div className={`${styles.modal_title}`}>{t("uploadDocument")}</div> */}
      <div className={`${styles.modal_title}`}>{t(isSourceAP ? "AP_info.uploadDocument" : "uploadDocument")}</div>
      <div className={`modal_subtitle ${styles.modal_subtitle}`}>{isSourceHatv ?  t("max_upload_size") : ""}</div>
      
      <div
        className={`upload_wrapper ${styles.upload_wrapper} ${isDragOver ? `uploading_state ${styles.uploading_state}` : ""}`}
        ref={dragDropRef}
      >            
        <input
          type="file"
          // accept="application/pdf,
          // application/vnd.openxmlformats-officedocument.wordprocessingml.document,
          // application/msword,
          // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, 
          // application/vnd.ms-excel,
          // application/vnd.openxmlformats-officedocument.presentationml.presentation,
          // application/vnd.ms-powerpoint"
          onChange={onFileChange}
          style={{ display: "none" }}
          ref={inputRef}
        />
        <div className={`upload_content ${styles.upload_content}`}>
          <div className={styles.icon_wrapper}>
            <img src={uploadDocIcon} alt={t("upload")} />
          </div>
          <div className={`${styles.upload_text}`}>{t(isSourceAP ? "AP_info.dragNDropMsg" : "dragNDropMsg")}</div>
          <div className={`${styles.upload_text}`}>{t(isSourceAP ? "AP_info.or" : "or")}</div>
          <div className={styles.upload_text} onClick={handleClick}>
          {t(isSourceAP ? "AP_info.chooseFromLocalDevice" : "chooseFromLocalDevice")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadComponent;
